import { Link } from 'react-router-dom';

export default function AboutPreview() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-3xl">
          {/* Label */}
          <span className="text-xs text-secondary-600 font-medium tracking-widest uppercase">
            关于古风
          </span>

          {/* Main title with inline decorative images */}
          <h2 className="mt-4 text-3xl md:text-5xl font-light text-primary-700 font-heading leading-tight">
            以古风之美
            <span className="inline-block w-8 h-8 md:w-10 md:h-10 rounded-full overflow-hidden align-middle mx-2">
              <img
                src="https://readdy.ai/api/search-image?query=Small%20oval%20traditional%20Chinese%20painting%2C%20elegant%20woman%20holding%20fan%2C%20warm%20peach%20tones%2C%20delicate%20brushwork%2C%20minimalist%20background&width=80&height=80&seq=about-oval-01&orientation=squarish"
                alt=""
                className="w-full h-full object-cover"
              />
            </span>
            诠释
            <br />
            韩漫新境界
            <span className="inline-block w-8 h-8 md:w-10 md:h-10 rounded-full overflow-hidden align-middle mx-2">
              <img
                src="https://readdy.ai/api/search-image?query=Small%20oval%20traditional%20Chinese%20landscape%20painting%2C%20blue%20green%20mountains%20and%20water%2C%20classical%20shan%20shui%20style%2C%20delicate%20details&width=80&height=80&seq=about-oval-02&orientation=squarish"
                alt=""
                className="w-full h-full object-cover"
              />
            </span>
            <br />
            为您精选每一页精彩
            <span className="inline-block w-6 h-6 md:w-7 md:h-7 rounded overflow-hidden align-middle ml-2">
              <img
                src="https://readdy.ai/api/search-image?query=Tiny%20square%20traditional%20Chinese%20ink%20stone%20and%20brush%20illustration%2C%20minimalist%2C%20warm%20sepia%20tones&width=56&height=56&seq=about-oval-03&orientation=squarish"
                alt=""
                className="w-full h-full object-cover"
              />
            </span>
          </h2>

          {/* Buttons */}
          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <Link
              to="/about"
              className="inline-flex items-center justify-center px-8 py-3 bg-primary-600 text-background-50 rounded-full text-sm font-medium hover:bg-primary-700 transition-all whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
            <Link
              to="/category/all"
              className="inline-flex items-center justify-center px-8 py-3 border border-primary-500 text-primary-600 rounded-full text-sm font-medium hover:bg-primary-50 transition-all whitespace-nowrap cursor-pointer"
            >
              浏览作品
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}